module.exports = __webpack_public_path__ + "media/images/front/icons/phone-blue-78937ef5dd467b39453a24a51a99e513.svg";